import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getSngLobbyService,
  registerSngService,
  unregisterSngService,
  markSngReadyService,
  getSngLeaderboardService,
  getSngMyStatsService,
  getSngStandingsService,
  getSngResultsService
} from 'network/services/sng.service'

export const getSngLobbyThunk = createAsyncThunk(
  'sng/getLobby',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await getSngLobbyService(params)
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch SNG lobby')
    }
  }
)

export const registerSngThunk = createAsyncThunk(
  'sng/register',
  async ({ tournamentId }, { rejectWithValue }) => {
    try {
      const response = await registerSngService({ tournamentId })
      return { tournamentId, ...(response || {}) }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to register')
    }
  }
)

export const unregisterSngThunk = createAsyncThunk(
  'sng/unregister',
  async ({ tournamentId }, { rejectWithValue }) => {
    try {
      const response = await unregisterSngService({ tournamentId })
      return { tournamentId, ...(response || {}) }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to unregister')
    }
  }
)

export const markSngReadyThunk = createAsyncThunk(
  'sng/markReady',
  async ({ tournamentId, tournamentTableId }, { rejectWithValue }) => {
    try {
      const response = await markSngReadyService({ tournamentId, tournamentTableId })
      return { tournamentId, tournamentTableId, ...(response || {}) }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to mark ready')
    }
  }
)

export const getSngLeaderboardThunk = createAsyncThunk(
  'sng/getLeaderboard',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await getSngLeaderboardService(params)
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch leaderboard')
    }
  }
)

export const getSngMyStatsThunk = createAsyncThunk(
  'sng/getMyStats',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await getSngMyStatsService(params)
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch stats')
    }
  }
)

export const getSngStandingsThunk = createAsyncThunk(
  'sng/getStandings',
  async (arg, { rejectWithValue }) => {
    try {
      const tournamentId = typeof arg === 'object' && arg != null
        ? arg.tournamentId
        : arg
      const tournamentTableId = typeof arg === 'object' && arg != null
        ? arg.tournamentTableId
        : undefined
      return await getSngStandingsService(tournamentId, {
        ...(tournamentTableId != null ? { tournamentTableId } : {})
      })
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch standings')
    }
  }
)

export const getSngResultsThunk = createAsyncThunk(
  'sng/getResults',
  async ({ tournamentId, tournamentTableId } = {}, { rejectWithValue }) => {
    try {
      return await getSngResultsService(tournamentId, {
        ...(tournamentTableId != null ? { tournamentTableId } : {})
      })
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message || 'Failed to fetch tournament results')
    }
  }
)
